export enum DialogSelectWarehouseLabels {
  errorMessage = 'Ocurrió un error al cambiar la bodega. Intenta de nuevo',
  noDataMessage = 'No se encontraron bodegas registradas',
  successMessage = 'La bodega ha sido cambiada correctamente'
}
